import { render, staticRenderFns } from "./editbranch.vue?vue&type=template&id=25a92c70&scoped=true"
import script from "./editbranch.js?vue&type=script&lang=js&external"
export * from "./editbranch.js?vue&type=script&lang=js&external"
import style0 from "./editbranch.vue?vue&type=style&index=0&id=25a92c70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a92c70",
  null
  
)

export default component.exports